import { makeStyles } from 'tss-react/mui';
import { styled } from '@mui/material/styles';
import Paper from '@mui/material/Paper';
import Grid from '@mui/material/Grid';
import { eventItems } from './showsContent/showsContent';
import { useIsMobile } from '../../utils/useIsMobile';

const useStyles = makeStyles()((theme) => ({
  showContainer: {
    padding: '0px 148px 0px 0px',
  },
  showContainerMobile: {
    padding: '0px 0px 32px 12px',
  },
}));

const Item = styled(Paper)(() => ({
  padding: '16px 0px',
  textAlign: 'left',
  backgroundColor: 'black',
  color: 'inherit',
}));

const ShowsComponent: React.FC = () => {
  const { classes } = useStyles();
  const isMobile = useIsMobile();

  return (
    <>
      {isMobile ? (
        <>
          <div className='title title-mobile content-wrapper'>KEIKAT</div>
          <div className='text-body text-body-mobile content-wrapper'>
            {eventItems.map((event) => {
              return (
                <div className={classes.showContainerMobile}>
                  <div>{`${event.date}, ${event.municipality}`}</div>
                  <div>{event.location}</div>
                  <div>{event.collab}</div>
                </div>
              );
            })}
          </div>
        </>
      ) : (
        <>
          <div className='title title-desktop content-wrapper'>KEIKAT</div>
          <div className='text-body text-body-desktop content-wrapper'>
            <div className={classes.showContainer}>
              {eventItems.map((event) => {
                return (
                  <Grid container spacing={2}>
                    <Grid size={1}></Grid>
                    <Grid size={2}>
                      <Item>{event.date}</Item>
                    </Grid>
                    <Grid size={2}>
                      <Item>{event.municipality}</Item>
                    </Grid>
                    <Grid size={2}>
                      <Item>{event.location}</Item>
                    </Grid>
                    <Grid size={3}>
                      <Item>{event.collab}</Item>
                    </Grid>
                  </Grid>
                );
              })}
            </div>
          </div>
        </>
      )}
    </>
  );
};

export default ShowsComponent;
